module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/pages/page-list/page-list.component.scss
// module id = ./libs/atenea-cms-brand/src/pages/page-list/page-list.component.scss
// module chunks = main